var React = require('react');

var GameStatus = React.createClass({
    render: function(){

        var broadcasts = this.props.broadcasts || {};
        var broadcastLink;

        if(broadcasts.url && broadcasts.name){
            broadcastLink = (
                <span className="network">
                    <a href={broadcasts.url} className={broadcasts.external === true ? "external" : ''}>{broadcasts.name}</a>
                </span>
            );
        }

        return (
            <div className="game-status">
                {broadcastLink}
                <span className="game-date">{this.props.status == 'pregame' ? this.props.date : ''}</span>
                <span className="game-time">{(this.props.time || '').toUpperCase()}</span>
                <span className="game-play"></span>
            </div>
        );
    }
});

var GameHeader = React.createClass({
    render: function(){
        var text = this.props.text;
        var details = (
            <div className="game-details header">
                {text}
            </div>
        );

        return text ? details : null;
    }
});

var Competitor = React.createClass({
    render: function(){

        var team = this.props.team;
        var isHomeTeam = this.props.team.home;
        var scoreContainer = (
            <div key={"score.container" + (this.props.team.home ? 'h' : 'a')}  className="score-container">
                <span className={"score icon-font-" + (!isHomeTeam ? 'before' : 'after')}>{this.props.score}</span>
            </div>
        );
        var teamForm = '';
        var teamInfoStyle = {};
        
        if(team.form && this.props.status === 'pregame'){
            teamForm = "Form: " + team.form;
        }else{
            teamInfoStyle = { top : '27px' };
        }
        
        var teamContainer = [
            <div key="team.container" className="team-container">
                <div className="logo">
                    <picture>
                        <source srcSet={team.logo}/>
                        <img data-default-src={team.logo} className="team-logo" src={team.logo}/>
                    </picture>
                </div>
                <div className="team-info" style={teamInfoStyle}>
                    <span className="rank"></span>
                    <span className="team-name">
                        <span className="long-name">{team.name}</span>
                        <span className="short-name">{team.name}</span>
                        <span className="abbrev">{team.abbreviation}</span>
                    </span>
                    <span className="record">{teamForm}</span>
                </div>
            </div>
        ];

        if(isHomeTeam){
            teamContainer.push(scoreContainer);
        }else{
            teamContainer.unshift(scoreContainer);
        }

        return (
            <div className={"team " + (!isHomeTeam ? 'home' : 'away')}>
                <div className="content">
                    {teamContainer}
                </div>
            </div>
        );
    }
});



var ScorecardStrip = React.createClass({
    render : function(){
        var classMap = {
            'pregame' : 'pre',
            'live' : 'live',
            'final' : 'post'
        };
        var headerClasses = ['game-strip'];

        headerClasses.push(this.props.sport || 'rugby', this.props.winnerClass || '', classMap[this.props.gameStatus] || '');

        return (
            <header style={this.props.styles} className={headerClasses.join(' ')}>
                <GameHeader text={this.props.heading} />
                <a data-route="false" href={this.props.anchor || '#'} className="competitors sm-score">
                    <Competitor team={this.props.teams.home} score={this.props.scores.home} status={this.props.gameStatus} />
                    <GameStatus broadcasts={this.props.broadcasts} status={this.props.gameStatus} date={this.props.formattedDate} time={this.props.time} />
                    <Competitor team={this.props.teams.away} score={this.props.scores.away} status={this.props.gameStatus} />
                </a>
            </header>
        );
    }
});

module.exports = ScorecardStrip;



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/scoreboard/game-strip/ScorecardStrip.jsx
 **/